import "./TermsOfService.module.css";
import Header from "@/reusable_sections/Header";
import WelcomeToOurTermsOfService from "./sections/WelcomeToOurTermsOfService";
import OurLegalTerms from "./sections/OurLegalTerms";
import QuestionsAndContactInformation from "./sections/QuestionsAndContactInformation";
import Footer from "@/reusable_sections/Footer";
export default function TermsOfServicePage() {
  return <div>
      <Header />
      <WelcomeToOurTermsOfService />
      <OurLegalTerms />
      <QuestionsAndContactInformation />
      <Footer />
    </div>;
}